<!--  ELLENŐRZŐ – a tanuló egy tanévének minden iskolai adata, szakaszonként (lásd a .ts fejkommentjét).
      Minden szakasznak saját betöltés-jelzője és hibaüzenete van: egy elbukó végpont csak a
      saját helyét üríti ki. -->
<div class="ell-fej">
  <ion-select class="ell-tanev" label="Tanév" label-placement="stacked" fill="outline" interface="popover"
              [(ngModel)]="tanev" (ionChange)="tanevValt()">
    <ion-select-option *ngFor="let t of tanevLista" [value]="t.id">{{ t.cimke }}</ion-select-option>
  </ion-select>
  <div class="ell-gombok">
    <ion-button size="small" fill="outline" (click)="mindet()">
      <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
    </ion-button>
    <ion-button size="small" (click)="pdf()" [disabled]="pdfFut">
      <ion-icon slot="start" name="print-outline"></ion-icon>Nyomtatás / PDF
    </ion-button>
  </div>
</div>

<!-- ── Osztály és csoportok ── -->
<section class="ell-szakasz">
  <h3 class="ell-cim"><ion-icon name="people-outline"></ion-icon>Osztály és csoportok</h3>
  <div *ngIf="tanugy.fut" class="ell-halvany"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
  <div *ngIf="tanugy.hiba" class="ell-hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ tanugy.hiba }}</div>
  <ng-container *ngIf="tanugy.adat">
    <div *ngIf="!jogviszonyok.length && !csoportok.length" class="ell-halvany">Nincs osztály- vagy csoporttagság a tanévben.</div>
    <div class="ell-chipek">
      <span class="ell-chip ell-chip-fo" *ngFor="let j of jogviszonyok"
            [title]="(j.kezdete || '…') + ' – ' + vegeSzoveg(j.vege)">
        {{ j.osztaly_nev || '–' }}<small *ngIf="j.evfolyam"> · {{ j.evfolyam }}. évf.</small>
        <small> · {{ j.kezdete || '…' }} – {{ vegeSzoveg(j.vege) }}</small>
      </span>
      <span class="ell-chip" *ngFor="let c of csoportok" [class.lezart]="c.vege && !c.vege.startsWith('0000') && c.vege < ma"
            [title]="(c.kezdete || '…') + ' – ' + vegeSzoveg(c.vege)">
        {{ c.csoport }}<small *ngIf="c.vege && !c.vege.startsWith('0000') && c.vege < ma"> (kilépett {{ c.vege }})</small>
      </span>
    </div>
  </ng-container>
</section>

<!-- ── Órarend ── -->
<section class="ell-szakasz">
  <div class="ell-cimsor">
    <h3 class="ell-cim"><ion-icon name="calendar-outline"></ion-icon>Órarend</h3>
    <div class="ell-het">
      <ion-button size="small" fill="clear" (click)="hetLeptet(-1)" title="Előző hét"><ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon></ion-button>
      <span>{{ hetCimke }}</span>
      <ion-button size="small" fill="clear" (click)="hetLeptet(1)" title="Következő hét"><ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon></ion-button>
      <ion-button size="small" fill="clear" (click)="hetLeptet(0)">Ma</ion-button>
    </div>
  </div>
  <div *ngIf="orarend.fut" class="ell-halvany"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
  <div *ngIf="orarend.hiba" class="ell-hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ orarend.hiba }}</div>
  <ng-container *ngIf="orarend.adat">
    <div *ngIf="!orarend.adat.length" class="ell-halvany">Ezen a héten nincs órája.</div>
    <div class="ell-racs-tarto" *ngIf="orarend.adat.length">
      <table class="ell-racs">
        <thead><tr><th></th><th *ngFor="let n of hetNapjai">{{ NAPOK[n] }}<small>{{ napDatum(n) }}</small></th></tr></thead>
        <tbody>
          <tr *ngFor="let ora of oraSorok">
            <th>{{ ora }}.</th>
            <td *ngFor="let n of hetNapjai">
              <div class="ell-ora" *ngFor="let o of cellaOrak(n, ora)" [class.elmarad]="elmaradtE(o)"
                   [class.hianyzott]="o.sajat?.hianyzott" [class.helyettes]="!!o.helyettesito"
                   [title]="(o.tantargy_nev || '') + (o.csoport_nev ? ' – ' + o.csoport_nev : '')">
                <b>{{ o.tantargy || o.tantargy_nev || '–' }}</b>
                <small *ngIf="o.terem"> {{ o.terem }}</small>
                <div class="ell-ora-tanar">{{ o.helyettesito ? o.helyettesito + ' (h.)' : (o.tarto || '') }}</div>
                <div class="ell-ora-jel" *ngIf="elmaradtE(o)">elmarad</div>
                <div class="ell-ora-jel" *ngIf="o.sajat?.hianyzott">hiányzott</div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</section>

<!-- ── Jegyek ── -->
<section class="ell-szakasz">
  <h3 class="ell-cim"><ion-icon name="ribbon-outline"></ion-icon>Értékelések</h3>
  <div *ngIf="jegyek.fut" class="ell-halvany"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
  <div *ngIf="jegyek.hiba" class="ell-hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ jegyek.hiba }}</div>
  <ng-container *ngIf="jegyek.adat">
    <div *ngIf="!tantargyak.length && !magatartasSzorgalom.length" class="ell-halvany">Nincs tantárgy vagy értékelés a tanévben.</div>
    <ng-template #jegySor let-t>
      <tr>
        <td data-cimke="Tantárgy"><b>{{ t.tantargy_nev || '–' }}</b></td>
        <td data-cimke="I. félév"><span class="ell-jegyek">
          <span *ngFor="let j of evkozi(t, 1)" class="ell-jegy" [ngClass]="'j-' + jegySzin(j)" [class.storno]="stornoE(j)" [title]="jegyCim(j)" [attr.data-negyedev]="negyedevJel(j)"><small *ngIf="negyedevJel(j) as jel" class="negyedev-jel">{{ jel }}</small>{{ jegyRovid(j) }}<sup *ngIf="+j.dicseretes">D</sup></span>
          <span *ngIf="!evkozi(t, 1).length" class="ell-halvany">–</span></span></td>
        <td data-cimke="Félévi" class="kozep"><span *ngFor="let j of zaro(t, '2')" class="ell-jegy zaro" [ngClass]="'j-' + jegySzin(j)" [title]="jegyCim(j)">{{ jegyRovid(j) }}</span></td>
        <td data-cimke="II. félév"><span class="ell-jegyek">
          <span *ngFor="let j of evkozi(t, 2)" class="ell-jegy" [ngClass]="'j-' + jegySzin(j)" [class.storno]="stornoE(j)" [title]="jegyCim(j)" [attr.data-negyedev]="negyedevJel(j)"><small *ngIf="negyedevJel(j) as jel" class="negyedev-jel">{{ jel }}</small>{{ jegyRovid(j) }}<sup *ngIf="+j.dicseretes">D</sup></span>
          <span *ngIf="!evkozi(t, 2).length" class="ell-halvany">–</span></span></td>
        <td data-cimke="Év végi" class="kozep"><span *ngFor="let j of zaro(t, '3')" class="ell-jegy zaro" [ngClass]="'j-' + jegySzin(j)" [title]="jegyCim(j)">{{ jegyRovid(j) }}</span></td>
        <td data-cimke="Átlag" class="jobb"><b>{{ atlag(t) }}</b></td>
      </tr>
    </ng-template>
    <table class="ell-tabla" *ngIf="tantargyak.length || magatartasSzorgalom.length">
      <thead><tr><th>Tantárgy</th><th>I. félév</th><th class="kozep">Félévi</th><th>II. félév</th><th class="kozep">Év végi</th><th class="jobb">Átlag</th></tr></thead>
      <tbody>
        <ng-container *ngFor="let t of tantargyak">
          <ng-container *ngTemplateOutlet="jegySor; context: { $implicit: t }"></ng-container>
        </ng-container>
        <tr class="ell-csoportsor" *ngIf="magatartasSzorgalom.length"><td colspan="6">Magatartás és szorgalom</td></tr>
        <ng-container *ngFor="let t of magatartasSzorgalom">
          <ng-container *ngTemplateOutlet="jegySor; context: { $implicit: t }"></ng-container>
        </ng-container>
      </tbody>
    </table>
    <div class="ell-halvany" *ngIf="tantargyak.length">A jegy fölé állva látszik a dátum, a típus, a téma és a tanár. „D” = dicséretes, áthúzott = stornózott, N1–N4 = negyedéves.</div>
  </ng-container>
</section>

<!-- ── Bejelentett számonkérések ── -->
<section class="ell-szakasz">
  <h3 class="ell-cim"><ion-icon name="document-text-outline"></ion-icon>Bejelentett számonkérések</h3>
  <div *ngIf="szamonkeres.fut" class="ell-halvany"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
  <div *ngIf="szamonkeres.hiba" class="ell-hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ szamonkeres.hiba }}</div>
  <ng-container *ngIf="szamonkeres.adat">
    <div *ngIf="!szamonkeres.adat.length" class="ell-halvany">Nincs bejelentett számonkérés.</div>
    <table class="ell-tabla" *ngIf="szamonkeres.adat.length">
      <thead><tr><th>Dátum</th><th>Tantárgy</th><th>Típus</th><th>Téma</th></tr></thead>
      <tbody>
        <tr *ngFor="let s of szamonkeres.adat" [class.mult]="s.datum < ma">
          <td data-cimke="Dátum">{{ s.datum }}</td>
          <td data-cimke="Tantárgy"><b>{{ s.tantargy_nev || '–' }}</b><div *ngIf="s.csoport_nev"><small>{{ s.csoport_nev }}</small></div></td>
          <td data-cimke="Típus">{{ s.tipus_nev || '–' }}</td>
          <td data-cimke="Téma">{{ s.cim || '' }}<div *ngIf="s.leiras"><small>{{ s.leiras }}</small></div></td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</section>

<!-- ── Mulasztások és késések ── -->
<section class="ell-szakasz">
  <h3 class="ell-cim"><ion-icon name="time-outline"></ion-icon>Mulasztások</h3>
  <div *ngIf="mulasztas.fut" class="ell-halvany"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
  <div *ngIf="mulasztas.hiba" class="ell-hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ mulasztas.hiba }}</div>
  <ng-container *ngIf="mulasztas.adat">
    <div class="ell-szamok" *ngIf="mulasztasOsszesito as o">
      <div class="ell-szam"><b>{{ o.nap }}</b><span>nap</span></div>
      <div class="ell-szam"><b>{{ o.ora }}</b><span>óra</span></div>
      <div class="ell-szam ok"><b>{{ o.igazolt }}</b><span>igazolt</span></div>
      <div class="ell-szam figy"><b>{{ o.igazolando }}</b><span>igazolandó</span></div>
      <div class="ell-szam baj"><b>{{ o.igazolatlan }}</b><span>igazolatlan</span></div>
      <div class="ell-szam" *ngIf="mulasztas.adat.keret_nap != null"><b>{{ mulasztas.adat.felhasznalt || 0 }}/{{ mulasztas.adat.keret_nap }}</b><span>szülői keret</span></div>
    </div>
    <div class="ell-chipek" *ngIf="mulasztasOsszesito.tipusok.length">
      <span class="ell-chip" *ngFor="let x of mulasztasOsszesito.tipusok">{{ x.nev }}: <b>{{ x.db }}</b> óra</span>
    </div>
    <div *ngIf="!mulasztasNapok.length" class="ell-halvany">Nincs rögzített mulasztás a tanévben.</div>
    <table class="ell-tabla" *ngIf="mulasztasNapok.length">
      <thead><tr><th>Dátum</th><th class="kozep">Órák</th><th>Órák és igazolásuk</th></tr></thead>
      <tbody>
        <tr *ngFor="let n of mulasztasNapok">
          <td data-cimke="Dátum"><b>{{ n.datum }}</b></td>
          <td data-cimke="Órák" class="kozep">{{ n.ora_db ?? n.orak?.length }}</td>
          <td data-cimke="Igazolás"><span class="ell-orak">
            <span *ngFor="let o of n.orak" class="ell-mini" [ngClass]="'j-' + igazolasSzin(o.igazolas_tipus)"
                  [title]="igazolasNev(o.igazolas_tipus)">{{ o.ora }}. {{ o.tantargy }}</span></span>
            <div *ngIf="n.sajat_igazolas"><small>Szülői beadás: {{ n.sajat_igazolas.statusz }}{{ n.sajat_igazolas.indoklas ? ' – ' + n.sajat_igazolas.indoklas : '' }}</small></div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="ell-halvany" *ngIf="mulasztasNapok.length">Zöld = igazolt (a típus az óra fölé állva látszik), sárga = igazolandó, piros = igazolatlan.</div>
  </ng-container>

  <h4 class="ell-alcim">Késések</h4>
  <div *ngIf="keses.fut" class="ell-halvany"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
  <div *ngIf="keses.hiba" class="ell-hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ keses.hiba }}</div>
  <ng-container *ngIf="keses.adat">
    <div *ngIf="!(keses.adat.tetelek || []).length" class="ell-halvany">Nincs késés a tanévben.</div>
    <ng-container *ngIf="(keses.adat.tetelek || []).length">
      <div class="ell-halvany">
        Igazolatlan: <b>{{ keses.adat.perc_igazolatlan || 0 }} perc</b> ({{ keses.adat.ora_igazolatlan || 0 }} óra) ·
        igazolt: <b>{{ keses.adat.perc_igazolt || 0 }} perc</b> ({{ keses.adat.ora_igazolt || 0 }} óra) –
        {{ keses.adat.perc_egy_ora || 45 }} perc késés egy mulasztott óra.
      </div>
      <table class="ell-tabla">
        <thead><tr><th>Dátum</th><th class="kozep">Óra</th><th>Tantárgy</th><th class="jobb">Perc</th><th>Igazolás</th></tr></thead>
        <tbody>
          <tr *ngFor="let k of keses.adat.tetelek" [class.mult]="!k.beszamit">
            <td data-cimke="Dátum">{{ k.datum | date: 'yyyy-MM-dd' }}</td>
            <td data-cimke="Óra" class="kozep">{{ k.oraszam != null ? k.oraszam + '.' : '' }}</td>
            <td data-cimke="Tantárgy">{{ k.tantargy_nev || '–' }}</td>
            <td data-cimke="Perc" class="jobb">{{ k.perc }}</td>
            <td data-cimke="Igazolás">
              <ion-badge [color]="+k.igazolt ? 'success' : 'danger'">{{ +k.igazolt ? 'igazolt' : 'igazolatlan' }}</ion-badge>
              <small *ngIf="k.indok"> {{ k.indok }}</small>
              <small *ngIf="!k.beszamit"> (nem számít bele)</small>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </ng-container>
</section>

<!-- ── Feljegyzések ── -->
<section class="ell-szakasz">
  <h3 class="ell-cim"><ion-icon name="create-outline"></ion-icon>Feljegyzések, beírások</h3>
  <div *ngIf="feljegyzes.fut" class="ell-halvany"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
  <div *ngIf="feljegyzes.hiba" class="ell-hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ feljegyzes.hiba }}</div>
  <ng-container *ngIf="feljegyzes.adat">
    <div class="ell-chipek" *ngIf="feljegyzesOsszesito.length">
      <span class="ell-chip" *ngFor="let x of feljegyzesOsszesito" [ngClass]="'c-' + feljegyzesSzin(x.nev)">{{ x.nev }}: <b>{{ x.db }}</b></span>
    </div>
    <div *ngIf="!feljegyzesek.length && !oraiBejegyzesek.length" class="ell-halvany">Nincs feljegyzés vagy órai bejegyzés a tanévben.</div>
    <table class="ell-tabla" *ngIf="feljegyzesek.length">
      <thead><tr><th>Dátum</th><th>Típus</th><th>Szöveg</th><th>Rögzítette</th></tr></thead>
      <tbody>
        <tr *ngFor="let f of feljegyzesek">
          <td data-cimke="Dátum">{{ f.datum }}</td>
          <td data-cimke="Típus"><ion-badge [color]="feljegyzesSzin(f.tipus)">{{ f.tipus }}</ion-badge>
            <div *ngIf="f.csak_admin"><small>hivatalos bejegyzés (a családnak nem látszik)</small></div></td>
          <td data-cimke="Szöveg" class="ell-szoveg"><b *ngIf="f.cim">{{ f.cim }}<br></b>{{ f.szoveg }}</td>
          <td data-cimke="Rögzítette">{{ f.tanar_nev || '–' }}</td>
        </tr>
      </tbody>
    </table>
    <ng-container *ngIf="oraiBejegyzesek.length">
      <h4 class="ell-alcim">Órai bejegyzések (házi feladat, felszerelés, dicséret)</h4>
      <table class="ell-tabla">
        <thead><tr><th>Dátum</th><th class="kozep">Óra</th><th>Tantárgy</th><th>Bejegyzés</th><th>Tanár</th></tr></thead>
        <tbody>
          <tr *ngFor="let o of oraiBejegyzesek">
            <td data-cimke="Dátum">{{ o.datum }}</td>
            <td data-cimke="Óra" class="kozep">{{ o.ora != null ? o.ora + '.' : '' }}</td>
            <td data-cimke="Tantárgy">{{ o.tantargy_nev || '–' }}</td>
            <td data-cimke="Bejegyzés"><ion-badge [color]="feljegyzesSzin(o.tipus)">{{ o.tipus }}</ion-badge></td>
            <td data-cimke="Tanár">{{ o.tanar_nev || '–' }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </ng-container>
</section>

<!-- ── Közösségi szolgálat ── -->
<section class="ell-szakasz">
  <h3 class="ell-cim"><ion-icon name="hand-left-outline"></ion-icon>Közösségi szolgálat</h3>
  <div *ngIf="iksz.fut" class="ell-halvany"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
  <div *ngIf="iksz.hiba" class="ell-hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ iksz.hiba }}</div>
  <ng-container *ngIf="iksz.adat">
    <div class="ell-halvany">
      Teljesítve: <b>{{ iksz.adat.ora || 0 }} / {{ iksz.adat.cel }} óra</b>
      <ion-badge *ngIf="iksz.adat.teljesitve" color="success">teljesítve</ion-badge>
      <span *ngIf="!iksz.adat.teljesitve"> – hiányzik {{ iksz.adat.hianyzik }} óra</span>
      (a teljes középiskolai időszakra, nem tanévenként).
    </div>
    <table class="ell-tabla" *ngIf="(iksz.adat.tetelek || []).length">
      <thead><tr><th>Időszak</th><th>Tevékenység</th><th>Hely</th><th class="jobb">Óra</th></tr></thead>
      <tbody>
        <tr *ngFor="let x of iksz.adat.tetelek">
          <td data-cimke="Időszak">{{ x.kezdete }} – {{ x.vege }}</td>
          <td data-cimke="Tevékenység">{{ x.tipus || '–' }}</td>
          <td data-cimke="Hely">{{ x.teljesitesi_hely || '–' }}</td>
          <td data-cimke="Óra" class="jobb">{{ x.oraszam }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</section>

<!-- ── Felmentések ── -->
<section class="ell-szakasz">
  <h3 class="ell-cim"><ion-icon name="shield-checkmark-outline"></ion-icon>Felmentések</h3>
  <div *ngIf="tanugy.fut" class="ell-halvany"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
  <div *ngIf="tanugy.hiba" class="ell-hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ tanugy.hiba }}</div>
  <ng-container *ngIf="tanugy.adat">
    <div *ngIf="!felmentesek.length" class="ell-halvany">Nincs felmentés a tanévben.</div>
    <table class="ell-tabla" *ngIf="felmentesek.length">
      <thead><tr><th>Tantárgy</th><th>Időszak</th><th>Mi alól</th><th>Ok / határozat</th></tr></thead>
      <tbody>
        <tr *ngFor="let f of felmentesek">
          <td data-cimke="Tantárgy"><b>{{ f.tantargy_nev || '–' }}</b></td>
          <td data-cimke="Időszak">{{ f.kezdete || '?' }} – {{ f.vege || 'visszavonásig' }}</td>
          <td data-cimke="Mi alól">{{ felmentesMiAlol(f) }}</td>
          <td data-cimke="Ok">{{ f.ok || '–' }}<div *ngIf="f.hatarozat"><small>{{ f.hatarozat }}</small></div></td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</section>

<!-- ── Záradékok ── -->
<section class="ell-szakasz">
  <h3 class="ell-cim"><ion-icon name="bookmark-outline"></ion-icon>Záradékok</h3>
  <div *ngIf="zaradek.fut" class="ell-halvany"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
  <div *ngIf="zaradek.hiba" class="ell-hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ zaradek.hiba }}</div>
  <ng-container *ngIf="zaradek.adat">
    <div *ngIf="!zaradekok.length" class="ell-halvany">Nincs záradék a tanévben.</div>
    <table class="ell-tabla" *ngIf="zaradekok.length">
      <thead><tr><th>Dátum</th><th>Kód</th><th>Szöveg</th></tr></thead>
      <tbody>
        <tr *ngFor="let z of zaradekok">
          <td data-cimke="Dátum">{{ z.datum || '–' }}</td>
          <td data-cimke="Kód">{{ z.melleklet_kod || '–' }}</td>
          <td data-cimke="Szöveg" class="ell-szoveg">{{ z.szoveg }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</section>
